import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-konkan-kanya-registartion',
  templateUrl: './konkan-kanya-registartion.component.html',
  styleUrls: ['./konkan-kanya-registartion.component.scss']
})
export class KonkanKanyaRegistartionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
